import { useState, useEffect } from "react";
import Markdown from "react-markdown";

const demos = [
  // {
  //   id: "demo-02",
  //   title: "App overview",
  //   subtitle: "3 skills (Sleep, Exercise, Stress) with skill-specific AI",
  //   src: "/design/demo-02.html",
  //   md: "/design/demo-02.md",
  // },
  // {
  //   id: "library",
  //   title: "Skills Library",
  //   subtitle: "Skills library — browse, install, and manage health skills",
  //   src: "/design/skills.html",
  //   md: "/design/skills.md",
  // },
  {
    id: "skill-library",
    title: "Skill library",
    subtitle: "Skill library, with search, install/uninstall, purchase/refund flows",
    src: "/design/demo-skill-library.html",
    md: "/design/demo-skill-library.md",
  },
  {
    id: "skill-install",
    title: "Skill install",
    subtitle: "Skill install flow — find, select, install a health skill",
    src: "/design/demo-skill-install.html",
    md: "/design/demo-skill-install.md",
  },
  {
    id: "skill-create",
    title: "Skill create",
    subtitle: "Skill create flow — find resource, process it, create and install a skill",
    src: "/design/demo-skill-create.html",
    md: "/design/demo-skill-create.md",
  },
];

function useMarkdown(url) {
  const [content, setContent] = useState("");
  useEffect(() => {
    setContent("");
    if (!url) return;
    fetch(url)
      .then((r) => r.text())
      .then(setContent)
      .catch(() => setContent("*Failed to load description.*"));
  }, [url]);
  return content;
}

export default function DemosPage() {
  const [active, setActive] = useState(demos[0].id);
  const current = demos.find((d) => d.id === active);
  const markdown = useMarkdown(current.md ?? null);

  return (
    <div className="min-h-screen px-6 py-14 sm:px-8">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <a
          href="/private/design"
          className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-kin-muted transition hover:text-kin-body"
        >
          <span>&#8249;</span> Brand Guidelines
        </a>

        <p className="text-sm font-medium tracking-widest uppercase text-kin-muted">
          Design Exploration
        </p>
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-kin-black font-serif sm:text-5xl">
          Wireframe Demos
        </h1>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-kin-body">
          Interactive wireframe prototypes exploring information architecture and navigation
          patterns. Toggle light/dark themes, tap tabs, and swipe carousels inside each demo.
        </p>

        {/* Tab switcher */}
        <div className="mt-8 flex gap-3">
          {demos.map((d) => (
            <button
              type="button"
              key={d.id}
              onClick={() => setActive(d.id)}
              className={`rounded-lg px-4 py-2.5 text-sm font-medium transition text-left ${
                active === d.id
                  ? "bg-kin-black text-kin-white shadow-sm"
                  : "bg-kin-white/70 text-kin-muted hover:text-kin-body hover:bg-white/80 border border-kin-olive/10"
              }`}
            >
              <span className="block">{d.title}</span>
              <span className="block text-xs opacity-60 mt-0.5">{d.subtitle}</span>
            </button>
          ))}
        </div>

        {/* Iframe */}
        <div className="mt-8 overflow-hidden rounded-2xl border border-kin-olive/10 bg-white shadow-sm">
          <iframe
            key={current.id}
            src={current.src}
            title={current.title}
            className="w-full border-0"
            style={{ height: "820px" }}
          />
        </div>

        {/* Open in new tab link */}
        <div className="mt-4 text-center">
          <a
            href={current.src}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-kin-muted transition hover:text-kin-green"
          >
            Open in new tab &#8599;
          </a>
        </div>

        {/* Rendered markdown description */}
        {markdown && (
          <div className="mt-12 mx-auto max-w-3xl">
            <div className="prose-kin text-sm leading-relaxed text-kin-body [&_h1]:mt-10 [&_h1]:mb-3 [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-kin-black [&_h1]:font-serif [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-kin-black [&_h2]:font-serif [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:tracking-wide [&_h3]:uppercase [&_h3]:text-kin-muted [&_p]:mb-3 [&_strong]:font-semibold [&_strong]:text-kin-dark [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_ul]:space-y-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-3 [&_ol]:space-y-1 [&_li]:pl-1 [&_hr]:my-8 [&_hr]:border-kin-olive/10 [&_table]:w-full [&_table]:mt-4 [&_table]:mb-4 [&_table]:text-xs [&_th]:text-left [&_th]:py-2 [&_th]:px-3 [&_th]:border-b [&_th]:border-kin-olive/15 [&_th]:font-semibold [&_th]:text-kin-muted [&_td]:py-2 [&_td]:px-3 [&_td]:border-b [&_td]:border-kin-olive/8">
              <Markdown>{markdown}</Markdown>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
